import type { MerchantApiClient } from "../../types.js";
import type { AuditEntry, AuditFilters, AuditPage } from "./models.js";

interface DataEnvelope<T> {
  data: T;
  meta: { requestId: string };
}

interface ListEnvelope<T> {
  items: T[];
  nextCursor: string | null;
  meta: { requestId: string };
}

export interface AuditApi {
  getAuditEntry(auditId: string): Promise<AuditEntry>;
  listAudit(filters: AuditFilters): Promise<AuditPage>;
}

export function createAuditApi(client: MerchantApiClient): AuditApi {
  return {
    async getAuditEntry(auditId) {
      return unwrap(
        await client.get<DataEnvelope<AuditEntry>>(`/v1/api/audit/${encodeURIComponent(auditId)}`),
      );
    },
    async listAudit(filters) {
      const envelope = await client.get<ListEnvelope<AuditEntry>>(
        `/v1/api/audit?${query(filters)}`,
      );
      return {
        entries: envelope.items,
        nextCursor: envelope.nextCursor,
        requestId: envelope.meta.requestId,
      };
    },
  };
}

function unwrap<T>(envelope: DataEnvelope<T>): T {
  return envelope.data;
}

function query(filters: AuditFilters): string {
  return new URLSearchParams(
    Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== "")
      .map(([key, value]) => [key, String(value)]),
  ).toString();
}
